// utils/orderUtils.ts

import { PaymentData } from "../../types/order";
import { OrderData } from "../types/order";

export const clearPaymentInput = (): PaymentData => ({
  discount: "",
  ReceivedAmount: "",
  paymentMethod: "",
});

export const handlePaymentInputChange = (e: React.ChangeEvent<HTMLInputElement>, order: OrderData | null, setPaymentData: React.Dispatch<React.SetStateAction<PaymentData>>) => {
  const { name, value } = e.target;
  const remainingAmount = parseFloat(order?.RemainingAmount ?? "0");

  if (value === "" || /^\d*\.?\d*$/.test(value)) {
    const inputAsNumber = parseFloat(value || "0");
    if (!isNaN(inputAsNumber) && inputAsNumber <= remainingAmount) {
      setPaymentData((prev) => ({ ...prev, [name]: value }));
    }
  }
};

export const formatDate = (date: Date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

export const formatTime = (date: Date) => `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
